const INACTIVITY_TIMEOUT_MS = 60 * 60 * 1000;
const LAST_ACTIVITY_KEY = "ims_last_activity_at";

let inactivityTimerId = null;

function getNow() {
  return Date.now();
}

export function getLastActivityAt() {
  const raw = localStorage.getItem(LAST_ACTIVITY_KEY);
  const value = Number(raw);
  return Number.isFinite(value) ? value : 0;
}

export function markActivity() {
  localStorage.setItem(LAST_ACTIVITY_KEY, String(getNow()));
}

export function clearActivity() {
  localStorage.removeItem(LAST_ACTIVITY_KEY);
}

export function isInactivityExceeded() {
  const lastActivityAt = getLastActivityAt();
  if (!lastActivityAt) return false;
  return getNow() - lastActivityAt >= INACTIVITY_TIMEOUT_MS;
}

function getRemainingIdleMs() {
  const lastActivityAt = getLastActivityAt();
  if (!lastActivityAt) return INACTIVITY_TIMEOUT_MS;
  const elapsed = getNow() - lastActivityAt;
  return Math.max(INACTIVITY_TIMEOUT_MS - elapsed, 0);
}

export function stopInactivityMonitor() {
  if (inactivityTimerId) {
    clearTimeout(inactivityTimerId);
    inactivityTimerId = null;
  }
}

export function startInactivityMonitor(onTimeout) {
  const schedule = () => {
    stopInactivityMonitor();
    inactivityTimerId = setTimeout(() => {
      if (isInactivityExceeded()) {
        onTimeout();
        return;
      }
      schedule();
    }, getRemainingIdleMs());
  };

  schedule();
}

export { INACTIVITY_TIMEOUT_MS };
